<template>
    <div ref="container">
        <StickyContainer
            v-bind="$attrs"
            ref="sticky"
            :offset="offset"
        >
            <slot></slot>
        </StickyContainer>
        <!-- spacer -->
        <div :style="{ height: `${scrollDistance}px` }"></div>
    </div>
</template>

<script>
import StickyContainer from '@/components/StickyContainer';
import { isRectInViewport } from '@helpers/dom';

/**
 * This component provides a container for a sticky element where you want scroll feedback while it is sticky
 * @emits scrolled - distance scrolled while element is sticky
 */
export default {
    name: 'StickyScrollContainer',

    components: {
        StickyContainer,
    },

    inheritAttrs: false,

    /* you can also use props from StickyContainer */
    props: {
        scrollDistance: {
            type: [Number, String],
            required: true,
        },
        offset: {
            type: [Number, String],
            required: true,
        },
        /** when toggled, the 'scrolled' event will also be emitted when the sticky element is not sticky, but visible on screen */
        emitMore: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['scrolled'],

    created() {
        this.scrolled = 0;

        window.addEventListener('scroll', this.checkScrollDistance);
        window.addEventListener('resize', this.checkScrollDistance);
    },

    beforeUnmount() {
        window.removeEventListener('scroll', this.checkScrollDistance);
        window.removeEventListener('resize', this.checkScrollDistance);
    },

    methods: {
        checkScrollDistance() {
            let scrolled = null;

            if (!this.$refs.container || !this.$refs.sticky) return;

            if (this.emitMore) {
                const rect = this.$refs.container.getBoundingClientRect();

                if (!isRectInViewport(rect)) return;

                scrolled = -(rect.top - this.offset);
            } else {
                scrolled = this.$refs.sticky.$el.offsetTop - this.$refs.container.offsetTop;
            }

            if (this.scrolled === scrolled) return;
            this.scrolled = scrolled;

            this.$emit('scrolled', scrolled);
        },
    },
};
</script>
